export default __webpack_public_path__ + "static/media/direito-agronegocio.08453ef9.png";